import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'promotions-product',
  props: {
    promotionsProduct: {
      type: [Object, Array],
      required: true,
    },
  },
  computed: {
    hasMultipleProducts() {
      return this.promotionsProduct.basketIds &&
             Array.isArray(this.promotionsProduct.basketIds) &&
             this.promotionsProduct.basketIds.length > 1;
    },
    hasSingleProduct() {
      return this.promotionsProduct.basketIds &&
             Array.isArray(this.promotionsProduct.basketIds) &&
             this.promotionsProduct.basketIds.length === 1;
    },
    hasLink() {
      return !!this.promotionsProduct.link;
    }
  },
  methods: {
    ...mapMutations({
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      changeBasketPopup: 'popups/CHANGE_BASKET_POPUP',
      changeSeminarDetailsPopup: 'popups/CHANGE_SEMINAR_DETAILS_POPUP',
    }),
    ...mapActions({
      fetchPromotionsProductsForBasket: 'promotions/FETCH_PROMOTIONS_PRODUCTS_FOR_BASKET',
    }),
    showUnavailableModal() {
      this.changeSeminarDetailsPopup({
        status: true,
        payload: {
          title: '',
          detail: this.promotionsProduct.unauthorizedText,
        },
      })
    },
    async addAllProductsToBasket() {
      const ids = this.promotionsProduct.basketIds.map((item) => item)
      const response = await this.fetchPromotionsProductsForBasket(ids)
      response.data.map((item) => {
        const productPrice = item.productPrices.data.find(productPrice => !productPrice.showWithoutPrice)
        this.addToBasket({
          select_count: 1,
          product_price: productPrice,
          product: item,
        })
      })
      this.changeBasketPopup(true)
    },
    async handleProductClick() {
      if (this.hasMultipleProducts && this.hasLink) {
        window.location.href = this.promotionsProduct.link;
        return;
      }
      if (this.hasMultipleProducts && !this.hasLink) {
        await this.addAllProductsToBasket()
      }

      if (this.hasSingleProduct) {
        try {
          const basketIds = this.promotionsProduct.basketIds[0];
          const product = await this.fetchPromotionsProductsForBasket([basketIds]);
          const slug = product.data[0].slug
          this.$router.push(this.$localize({name: 'card', params: {slug: slug}}))
        } catch (error) {
          console.error('Error fetching product:', error);
        }
      }
    }
  },
  data() {
    return {}
  },
}
